<template>
    <div>
        <main class="d-flex justify-content-center inicio-home">
            <div class="container p-5">
                <div class="row d-flex justify-content-center">
                    <div class="col-md-8  bg-body rounded shadow-sm p-5">
                        <h3 class="d-flex justify-content-start">Perfil</h3>
                       <hr>
                        <div class="d-flex justify-content-between" v-if="isLoad">
                            <div class="col-md-6 d-flex justify-content-start">
                                <ul class="list-ope">
                                    <li class="m-t-2">Correo electrónico</li>
                                    <li class="m-t-2">Número de teléfono celular</li>
                                    <li class="m-t-2">Domiciliado</li>
                                    <li class="m-t-2">Tipo de indentidad  </li>
                                    <li class="m-t-2">Numero de indentidad  </li>
                                    <li class="m-t-2">Fecha de nacimiento</li>
                                    <li class="m-t-2">Nacionalidad</li>
                                    <li class="m-t-2">País de residencia</li>
                                </ul>
                            </div>
                            <div class="col-md-6 d-flex justify-content-end">
                                <ul class="list-ope">
                                    <li class="m-t-2" v-text="datosPersonales.Email"></li>
                                    <li class="m-t-2" v-text="datosPersonales.Celular"></li>
                                    <li class="m-t-2" v-text="datosPersonales.Domiciliado"></li>
                                    <li class="m-t-2" v-text="tipodoc"></li>
                                    <li class="m-t-2" v-text="datosPersonales.NumeroDocumentoIdentidad"></li>
                                    <li class="m-t-2" v-text="datosPersonales.FechaNacimiento"></li>
                                    <li class="m-t-2" v-text="nacionalidad"></li>
                                    <li class="m-t-2" v-text="pais"></li>
                                </ul>
                                </div>
                            </div>
                            <div v-if="!isLoad" class="cargando"></div>
                            <br>
                            <div class="col-md-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-registro  me-2" @click="$router.push('/user-editar-perfil-usuario').catch(err => {})"><i class="far fa-edit"></i> Editar perfil</button>
                            <button type="button" class="btn btn-iniciar-sesion" @click="cerrarSesion"> <i class="fas fa-power-off"></i> Cerrar sesión</button></div>
                        </div>
                        
                    </div>
                </div>
        </main>
    </div>
</template>

<script>
    import auth from '@/services/auth'
    
      export default {
        name: "Perfil",
    
        data() {
        return {
          datosPersonales:[],
          pais:"",
          nacionalidad:"",
          tipodoc:"",
          isLoad:false,
        };
      },
    
      mounted(){
        this.esperarTiempo();
      },
      beforeCreate(){
        

        auth.obtenerCliente(this).then(response => {
        if(response){
          this.datosPersonales=response;
          if(this.datosPersonales.Domiciliado==true)
          {
              this.datosPersonales.Domiciliado="SI";
          }
          else{
            this.datosPersonales.Domiciliado="NO"
          }
          auth.listParameters().then(response => {
        this.parametrosGenerales=response;
        this.obtenerSelectPais();
         this.isLoad = true
        });
        }
        else{
            this.$router.push("/auth-login").catch(err => {});
        }
        }).catch(error => {
            this.$router.push("/auth-login").catch(err => {});
        });

       
    },
      methods:{
        cerrarSesion(){
            if ( auth.cerrarSesion()){
                localStorage.removeItem("auth_token");
                this.$router.push("/inicio").catch(err => {});
            }
        },

        obtenerSelectPais(){
            this.pais=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Pais.find(e=>e.IdPais==this.datosPersonales.PaisResidencia).NombrePais;
            this.nacionalidad=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Pais.find(e=>e.IdPais==this.datosPersonales.Nacionalidad).NombrePais;
            this.tipodoc=this.parametrosGenerales.ParametrosGenerales.find(e=>e.Id==this.datosPersonales.IdTipoDocumentoIdentidad).NombreParametroValor;
            },
        esperarTiempo() {
             setTimeout(function() {
                // this.isLoad = true
             }.bind(this), 1000);
         }
      },
      };
      </script>


// WEBPACK FOOTER //
// src/components/user/Perfil.vue